document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-close-dialog')) return;

    e.target.closest('dialog').close();
});

document.addEventListener('click', (e) => {
    const dialog = e.target.closest('dialog');
    if (!dialog) return;

    const rect = dialog.getBoundingClientRect();
    const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width);

    if (!isInDialog) {
        dialog.close();
    }
});